import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchLinkLabel: {
		id: 'search-page.search-link.label',
		defaultMessage: 'Search Link',
		description: 'Aria label for search link result',
	},
});
